module.exports = __webpack_public_path__ + "static/media/eject.efcf93d5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/eject.mp3
// module id = 38
// module chunks = 1